export const mapOptionsDataProps = async (optionsData: any) => {
  return {
    ...optionsData
  }
}
